var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{class:[
    _vm.openDyslexic ? 'open-dyslexic' : '',
    _vm.$route.path === '/welcome' || _vm.$route.path == '/terms' ? 'border' : '',
    _vm.isAndroid ? 'android-top-safe-area android-bottom-safe-area' : '',
  ]},[(_vm.$route.path != '/welcome')?_c('BypassBlock'):_vm._e(),(
      _vm.$route.path != '/welcome' &&
      _vm.$route.name != 'user_register' &&
      _vm.$route.path != '/terms'
    )?_c('Header'):_vm._e(),_c('v-main',{class:[
      'main-content',
      {
        'main-content--yellow-background':
          _vm.$route.name === 'opportunities_archive' || _vm.$route.name === 'posts',
      },
      {
        'main-content--green-background':
          _vm.$route.name === 'organisations_archive' ||
          _vm.$route.name === 'sign_in' ||
          _vm.$route.name === 'sign_up' ||
          _vm.$route.name === 'forgot_password' ||
          _vm.$route.name === 'user_profile' ||
          _vm.$route.name === 'user_edit' ||
          _vm.$route.name === 'blocked_users',
      },
      {
        'main-content--pink-background':
          _vm.$route.name === 'surveys' ||
          _vm.$route.name === 'toolkit_archive' ||
          _vm.$route.name === 'toolkit_search' ||
          _vm.$route.name === 'toolkit_article',
      },
      {
        'main-content--orange-background': _vm.$route.name === 'chats',
      },
      {
        'main-content--events': _vm.$route.name === 'events_archive',
      },
      {
        'main-content--offers': _vm.$route.name === 'offers_archive',
      },
    ],attrs:{"id":"main-content","tabindex":"-1"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{key:_vm.$route.fullPath})],1),_c('v-alert',{staticClass:"network-error",attrs:{"dense":"","dismissible":"","type":"error"},model:{value:(_vm.networkAlert),callback:function ($$v) {_vm.networkAlert=$$v},expression:"networkAlert"}},[_vm._v("Network Error. Unable to fetch live data")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }